module.exports = __webpack_public_path__ + "static/DylanC-3de774766c843073e1b87d3313290200.png";